module.exports = {
          srcSet: __webpack_public_path__ + "public/images/1328931b6ed94d94726dc145bd0df36b-1200.webp"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/1328931b6ed94d94726dc145bd0df36b-1200.webp",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/1328931b6ed94d94726dc145bd0df36b-1200.webp",
          toString:function(){return __webpack_public_path__ + "public/images/1328931b6ed94d94726dc145bd0df36b-1200.webp"},
          
          width: 1200,
          height: 800
        }